// Custom hooks will be exported here
// export { useUser } from './useUser';
// export { useAuth } from './useAuth';
// export { useConsent } from './useConsent';
// export { useSupabase } from './useSupabase';

// Authentication hooks
export { useAuth } from "./useAuth";

// Placeholder export to prevent build errors
export const HOOKS_VERSION = "0.1.0";

export * from "./useKeyboardShortcuts";
export * from "./usePerformance";
